import { en, NAMESPACE } from '@/assets/locales/en.ts';
import { pl } from '@/assets/locales/pl.ts';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en,
  pl,
} as const;

i18n.use(initReactI18next).init<never>({
  defaultNS: NAMESPACE,
  detection: {
    caches: ['localStorage', 'cookie'],
    order: ['localStorage', 'cookie', 'navigator'],
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  lng: 'en',
  ns: [NAMESPACE],
  resources,
});
